import React from "react";

// HELPERS
import { createClassName, createUid } from "@helpers/utils";


export default class Checkbox extends React.PureComponent {
    uid = createUid()
    state = {
        focused: false
    }

    render() {
        const { props, state } = this;
        const { style, type, checked, label, title, name, value, required, disabled, tooltip, rounded, alignTop, labelAlign } = props;
        const classes = createClassName(props.className, {
            "Checkbox": true,
            "checked": checked,
            "focus": state.focused,
            "tooltip": !!tooltip,
            "required": required === true,
            "disabled": disabled === true,
            "radio": type === "radio",
            "round": rounded === true,
            "align-top": alignTop === true,
            "label-left": labelAlign === "left",
        });

        return (
            <div className={ classes } style={ style } title={ title }>
                <label htmlFor={ this.uid }>
                    { !!label && labelAlign === "left" && <div className="Checkbox-label">{ label }</div> }
                    <div className="Checkbox-checkbox">
                        <div className="icon material-icons">done</div>
                    </div>
                    { !!label && labelAlign !== "left" && <div className="Checkbox-label">{ label }</div> }
                </label>
                <input
                    ref={ ref => this.input = ref }
                    className="Checkbox-input"
                    type={ type === "radio" ? "radio" : "checkbox" }
                    id={ this.uid }
                    name={ name }
                    value={ value }
                    checked={ checked }
                    required={ required }
                    disabled={ disabled }
                    onFocus={ this._onFocus }
                    onBlur={ this._onBlur }
                    onChange={ this._onChange }
                />
                { !!tooltip && <CheckboxTooltip text={ tooltip } /> }
            </div>
        );
    }

    // Internal methods
    _onFocus = (args) => {
        const { onFocus } = this.props;
        this.setState({ focused: true }, onFocus ? onFocus(args) : null);
    }

    _onBlur = (args) => {
        const { onBlur } = this.props;
        this.setState({ focused: false }, onBlur ? onBlur(args) : null);
    }

    _onChange = (args) => {
        const { onChange } = this.props;

        if(onChange) {
            const { checked, value } = this.input;
            onChange(checked, value);
        }
    }
}


// PRIVATE COMPONENTS
function CheckboxTooltip({ text, onClick }) {
    return (
        <div className="Checkbox-tooltip">
            <div className="Checkbox-tooltip-icon">?</div>
            <div className="Checkbox-tooltip-text">{ text }</div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/Checkbox/Checkbox.js